module.exports = require("pikaday-ssrfix");